import styled from "styled-components";

export const RSSFeedPreview = styled.div``;

export const RSSFeedItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;

  :last-child {
    border: transparent;
  }
`;
